import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [status, setStatus] = useState("Finalising sign-in...");

  useEffect(() => {
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(data.user);
        toast.success(`Welcome, ${data.user.name.split(" ")[0]}`);
        // Clear the fragment
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user.is_admin ? "/admin" : "/dashboard", { replace: true });
      } catch (err) {
        setStatus("Sign-in failed. Redirecting...");
        setTimeout(() => navigate("/login", { replace: true }), 1200);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5]">
      <div className="text-center">
        <div className="inline-block w-10 h-10 border-2 border-[#1F3864] border-t-transparent rounded-full animate-spin mb-4" />
        <div className="text-[#1F3864] font-display text-2xl">{status}</div>
      </div>
    </div>
  );
}
